import { createAction } from 'redux-actions'

export const muteRemoteAudio = createAction('MUTE_REMOTE_AUDIO')
export const onAudioMuted = createAction('ON_AUDIO_MUTED')
export const muteAudio = createAction('MUTE_AUDIO')
export const onRemoteAudioMuted = createAction('ON_REMOTE_AUDIO_MUTED')
export const onMuteAudioProgressStateUpdate = createAction('ON_MUTE_AUDIO_PROGRESS_STATE_UPDATE')
export const updateRemoteAudioIndicator = createAction('UPDATE_REMOTE_AUDIO_INDICATOR')
